import { useCallback, useEffect, useState } from 'react';

export const APP_VIEWS = {
  matchups: { id: 'matchups', label: 'Matchups', hash: 'matchups' },
  decide: { id: 'decide', label: 'Decide', hash: 'decide' },
  draft: { id: 'draft', label: 'Draft', hash: 'draft' },
};

const LEGACY_HASH_MAP = {
  matchups: 'matchups',
  live: 'matchups',
  decide: 'decide',
  root: 'matchups',
  rooting: 'matchups',
  draft: 'draft',
  'draft-tool': 'draft',
  dynasty: 'draft',
  ktc: 'draft',
  'sleeper-ktc': 'draft',
};

/** Returns null when the URL carries no view, so the caller's default wins. */
export const parseViewFromHash = () => {
  const raw = window.location.hash.replace(/^#/, '').trim();
  if (!raw) return null;
  return LEGACY_HASH_MAP[raw] || null;
};

export const useAppView = (defaultView = 'matchups') => {
  const [view, setViewState] = useState(() => parseViewFromHash() || defaultView);

  const setView = useCallback((next) => {
    setViewState(next);
    const hash = APP_VIEWS[next]?.hash || 'matchups';
    const url = `${window.location.pathname}${window.location.search}#${hash}`;
    window.history.replaceState(null, '', url);
  }, []);

  useEffect(() => {
    const onHashChange = () => setViewState(parseViewFromHash() || defaultView);
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, [defaultView]);

  useEffect(() => {
    const raw = window.location.hash.replace(/^#/, '').trim();
    const resolved = parseViewFromHash() || defaultView;
    const canonicalHash = APP_VIEWS[resolved]?.hash || 'matchups';
    if (!raw || raw !== canonicalHash) {
      const url = `${window.location.pathname}${window.location.search}#${canonicalHash}`;
      window.history.replaceState(null, '', url);
    }
    if (resolved !== view) {
      setViewState(resolved);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { view, setView };
};
